import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from "react-redux";
import  premium_title  from '../../../../public/assets/images/premium_title.svg';

const PdpNewAds = ({
    adsData,  
}) => {

return(
<div className='left_side_widget' id="titleInsuranceAd">
<div className="newads" style={{}}>
<a className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
<img
   className=""
   src={adsData?.imgUrl}
   alt="bh1.jpg"/>
</a> 
    <p className="pdpText">{adsData?.description}</p>

</div>
</div>
)

};

export default PdpNewAds;
